import { useState, type ImgHTMLAttributes } from 'react';
import { responsiveImage } from '../../shared/image-delivery';

/** A derivative failure gets one retry with the untouched original. */
export function ResponsiveImage({
  src,
  sizes,
  onError,
  ...props
}: ImgHTMLAttributes<HTMLImageElement>) {
  const [fallback, setFallback] = useState('');
  const optimized = fallback !== src && responsiveImage(src, sizes);
  return (
    <img
      {...props}
      {...(optimized || { src })}
      onError={(event) => {
        if (optimized && optimized.srcSet) setFallback(src || '');
        else onError?.(event);
      }}
    />
  );
}
